import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { checkCreatorAddress, checkPaypalStatus, getDeal, getPaypalOnboardingLink, submitCampaign } from "../firebase";
import { Button, Checkbox, Spinner, Text, VerticalStack, Divider, HorizontalStack, AlphaCard, Avatar, HorizontalGrid, Select, RadioButton, TextField, Icon, Box, Image, Badge, List, Link } from "@shopify/polaris";
import { BehaviorMajor, ClockMinor, TickMinor, ShipmentMajor, LegalMajor, CustomersMajor, ImagesMajor, AddProductMajor, FormsMajor, PagePlusMajor, ProductsMajor, CashDollarMajor, ChecklistMajor } from "@shopify/polaris-icons";
import { AddressElement, useElements } from '@stripe/react-stripe-js';
import { Tiktok, Instagram, Youtube, numberToUSD } from "../utils";
import paypalIcon from "../assets/paypal-icon.png";
import { DetailText, SpacedText } from "../templates/Components";

const MAPS_KEY = 'AIzaSyACFv1SiRtvQ6IsAwoRJZeiT8c_UZp9pFQ'

function ContentItem({ format, quantity, showQuantity }) {
  const icon = (
    <HorizontalStack>
      <Icon source={format.includes('tiktok') ? Tiktok : format.includes('youtube') ? Youtube : format.includes('instagram') ? Instagram : BehaviorMajor} />
    </HorizontalStack>
  )
  let contentString = format;
  if (format === 'tiktokShort') {
    contentString = 'TikTok Short'
  } else if (format === 'instagramPost') {
    contentString = 'Instagram Post'
  } else if (format === 'instagramStory') {
    contentString = 'Instagram Story'
  } else if (format === 'youtubeVideo') {
    contentString = 'YouTube Video'
  } else if (format === 'instagramReel') {
    contentString = 'Instagram Reel'
  }
  if (format === 'instagramStory') {
    contentString = `${showQuantity ? quantity : ''} ${showQuantity && quantity === 1 ? 'Instagram Story' : 'Instagram Stories'}`
  } else {
    contentString = `${showQuantity ? quantity : ''} ${contentString}${showQuantity && quantity === 1 ? '' : 's'}`
  }
  return (
    <AlphaCard>
      <HorizontalStack gap="1" align="start">
        {icon}
        <Text variant="headingMd">{contentString}</Text>
      </HorizontalStack>
    </AlphaCard>
  )
}

export default function Onboarding() {
  useElements()

  const [localCampaign, setLocalCampaign] = useState(null);
  const [localSelectedVariants, setLocalSelectedVariants] = useState({})
  const [paypalLoading, setPaypalLoading] = useState(false)
  const [merchantIDSaved, setMerchantIDSaved] = useState(false)

  const [viewContract, setViewContract] = useState(false)

  const subdomain = window.location.hostname.split('.')[0];

  const urlParams = new URLSearchParams(window.location.search);
  const ID = urlParams.get('id');

  const [submitFormLoading, setSubmitFormLoading] = useState(false);
  const [submitFormError, setSubmitFormError] = useState(null);

  const {
    data: deal,
    isLoading,
    error,
    refetch
  } = useQuery({
    queryKey: ['getForm', ID],
    queryFn: async () => getDeal(ID)
  });

  const {
    data: paypalData,
    isLoading: paypalDataLoading,
    refetch: refetchPaypalData
  } = useQuery({
    queryKey: ['getPaypalData', deal?.creatorID],
    queryFn: async () => {
      if (deal?.creatorID) {
        return checkPaypalStatus({ creatorID: deal?.creatorID })
      }
      return null
    }
  })

  const {
    data: creatorAddress,
    isLoading: creatorAddressLoading,
  } = useQuery({
    queryKey: ['checkCreatorAddress', deal?.creatorID],
    queryFn: async () => {
      if (deal?.creatorID) {
        return checkCreatorAddress(deal?.creatorID)
      }
      return null
    }
  })

  console.log('creatorAddress', creatorAddress)

  useEffect(() => {
    const customFields = deal?.form?.customFields
    if (deal && customFields?.length > 0 && !localCampaign) {
      setLocalCampaign({
        customFields: customFields
          .filter(f => f.type === 'checkbox' || f.type === 'select')
          .reduce((a, f) => {
            if (f.type === 'checkbox') {
              a[f.label] = []
            } else if (f.type === 'select') {
              a[f.label] = f.options[0]
            }
            return a
          }, {})
      })
    }

    if (deal && !localCampaign) {
      console.log('local selvar', deal?.products?.selectedVariants.reduce((a, item) => {
        a[item.productID] = item
        return a
      }, {}))
      setLocalSelectedVariants(deal?.products?.selectedVariants.reduce((a, item) => {
        a[item.productID] = item
        return a
      }, {}))
    }

    if (deal?.store?.name) {
      window.document.title = deal.store.name
    }
  }, [deal])

  console.log('dealpr', deal?.products)

  async function handleSubmitCampaign() {
    try {
      setSubmitFormError(null);
      setSubmitFormLoading(true);
      await submitCampaign(
        deal.id,
        localCampaign
      );
      window.scrollTo(0, 0)
      refetch();
    } catch (e) {
      setSubmitFormError(e.message);
    } finally {
      setSubmitFormLoading(false);
    }
  }

  function hasMissingFields() {
    const requiredFields = deal?.form?.customFields?.filter(item => item.required);
    console.log('requiredFields', requiredFields)
    const missingFields = requiredFields?.filter(item => !localCampaign?.customFields?.[item.label]);
    return missingFields?.length > 0;
  }

  const totalSelectedQuantity = localCampaign?.products?.selectedVariants?.reduce((acc, item) => {
    return acc + 1
  }, 0)
  const totalSelectedValue = localCampaign?.products?.selectedVariants?.reduce((acc, item) => {
    return acc + Number(item.price)
  }, 0)

  const groupedVariants = deal?.products?.selectedVariants?.length ? deal?.products?.selectedVariants?.reduce((acc, variant) => {
    if (!acc[variant?.productID]) {
      acc[variant.productID] = {
        product: variant,
        variants: []
      }
    }
    acc[variant.productID].variants.push(variant);
    return acc
  }, {}) : {}

  const header = (
    <AlphaCard padding="0">
      <div style={{ padding: '40px 0', backgroundColor: 'white' }}>
        <VerticalStack gap="6" inlineAlign="center">
          <VerticalStack gap="2">
            <div style={{ textAlign: 'center' }}>
              {
                !viewContract ? (
                  <SpacedText>Apply For</SpacedText>
                ) : null
              }
            </div>
            <img src={deal?.store?.logo} style={{ width: '200px', height: 'auto' }} />
          </VerticalStack>
          <DetailText>{deal?.publicTitle}</DetailText>
        </VerticalStack>
      </div>
      <div style={{
        width: '100%',
        height: '300px',
        backgroundColor: 'lightgray',
        background: `url("${deal?.hero ? deal.hero : 'https://assets.codepen.io/6060109/default-lp-hero-1.jpg'}")`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: deal?.heroSize === 'Full Width' ? '100%' : deal?.heroSize === 'Full Height' ? 'auto 100%' : deal?.heroSize === 'contain' ? 'contain' : 'cover',
        backgroundPosition: deal?.heroPosition === 'top' ? 'top' : deal?.heroPosition === 'center' ? 'center' : 'bottom',
      }}>
      </div>
    </AlphaCard>
  )

  console.log('paypalData', paypalData)
  if (isLoading) {
    return (
      <HorizontalStack align="center">
        <Box paddingBlockStart="16" paddingBlockEnd="32" maxWidth="1000px" width="700px">
          <AlphaCard>
            <HorizontalStack align="center">
              <Spinner />
            </HorizontalStack>
          </AlphaCard>
        </Box>
      </HorizontalStack>
    )
  } else if (error) {
    return (
      <HorizontalStack align="center">
        <Box paddingBlockStart="16" paddingBlockEnd="32" maxWidth="1000px" width="700px">
          <AlphaCard>
            <HorizontalStack align="center">
              <Text color="critical">{error.message}</Text>
            </HorizontalStack>
          </AlphaCard>
        </Box>
      </HorizontalStack>
    )
  } else if (viewContract) {
    return (
      <HorizontalStack align="center">
        <Box paddingBlockStart="16" paddingBlockEnd="32" maxWidth="1000px" width="700px">
          <VerticalStack gap="3">
            {header}
            <AlphaCard>
              <VerticalStack gap="5">
                <HorizontalStack gap="3" align="start">
                  <HorizontalStack>
                    <Icon source={CustomersMajor} />
                  </HorizontalStack>
                  <VerticalStack gap="1">
                    <Text variant="headingMd">Campaign Overview</Text>
                  </VerticalStack>
                </HorizontalStack>
                <Divider />
                <VerticalStack gap="3">
                  <div dangerouslySetInnerHTML={{ __html: deal?.specs?.overview }} />
                </VerticalStack>
              </VerticalStack>

            </AlphaCard>
            {
              (deal?.payments?.includeAffiliate) && (
                <AlphaCard>
                  <VerticalStack gap="5">
                    <HorizontalStack align="space-between">
                      <HorizontalStack gap="3" align="start" blockAlign="center">
                        <HorizontalStack>
                          <Icon source={BehaviorMajor} />
                        </HorizontalStack>
                        <VerticalStack gap="1">
                          <Text variant="headingMd">Affiliate</Text>
                        </VerticalStack>
                      </HorizontalStack>
                    </HorizontalStack>
                    <Divider />
                    {
                      /*
                          deal?.affiliateFields?.code ? (
                            <>
                              <HorizontalStack align="start" gap="1">
                                <VerticalStack gap="1">
                                  <Text variant="bodyLg">Share this URL</Text>
                                  <Box onClick={() => copyToClipboard('https://' + storeCustomDomain + '.prup.io/' + deal?.affiliateFields?.code, setToasts)} >
                                    <HorizontalStack>
                                      <Link removeUnderline>{'https://' + storeCustomDomain + '.prup.io/' + deal?.affiliateFields?.code}</Link>
                                      <Icon color="interactive" source={DuplicateMinor} />
                                    </HorizontalStack>
                                  </Box>
                                </VerticalStack>
                              </HorizontalStack>
                              <Divider />
                            </>
                          ) : null
          */
                    }
                    <HorizontalGrid gap="5" columns="2">
                      <VerticalStack>
                        {
                          deal?.affiliateFields?.discountType === 'freeShipping' ? (
                            <Text variant="headingLg">Free Shipping{deal?.affiliateFields?.usOnly ? ', US Only' : ''}</Text>
                          ) : deal?.affiliateFields?.discountType === 'fixed' ? (
                            <Text variant="headingLg">${deal.affiliateFields?.discountFixedValue} Off Per Order</Text>
                          ) : (
                            <Text variant="headingLg">{deal.affiliateFields?.discountPercentage}% Discount</Text>
                          )
                        }
                        <Text>For Customers</Text>
                      </VerticalStack>
                      <VerticalStack>
                        <Text variant="headingLg">{deal.affiliateFields?.commission}% Commission</Text>
                        <Text>On Revenue You Generate</Text>
                      </VerticalStack>
                    </HorizontalGrid>
                  </VerticalStack>
                </AlphaCard>
              )
            }
            <AlphaCard>
              <VerticalStack gap="5">
                <HorizontalStack align="space-between">
                  <HorizontalStack gap="3" align="start" blockAlign="center">
                    <HorizontalStack>
                      <Icon source={ImagesMajor} />
                    </HorizontalStack>
                    <VerticalStack>
                      <Text variant="headingMd">Content</Text>
                    </VerticalStack>
                  </HorizontalStack>
                  <HorizontalStack gap="1">
                    <Badge>{deal?.content?.baseType}</Badge>
                    {
                      deal?.period && (
                        (!deal?.periodPaid && new Date(deal?.period.end) < new Date()) ? (
                          <Badge status="critical">Due {new Date(deal?.period?.end).toLocaleDateString()}</Badge>
                        ) : (
                          <Badge>Due {new Date(deal?.period?.end)?.toLocaleDateString()}</Badge>
                        )
                      )
                    }
                  </HorizontalStack>
                </HorizontalStack>
                <Divider />
                <HorizontalStack align="center" blockAlign="end" gap="5" columns={deal?.content?.baseType === 'evergreen' ? "2" : "4"}>
                  {
                    deal?.content?.formats?.map((format, index) => {
                      const key = Object.keys(format)[0]
                      const quantity = format[key]
                      console.log('format is', format)
                      return (
                        <ContentItem key={index} format={key} quantity={quantity} showQuantity={deal?.content?.baseType !== 'evergreen'} />
                      )
                    })
                  }
                  {
                    (deal?.content?.baseType !== 'evergreen') ? (
                      <VerticalStack inlineAlign="center">
                        <Text variant="headingLg">{deal.content?.dueInDays} Day</Text>
                        <Text variant="bodyMd">{deal?.content?.baseType === 'fixed' ? "Deadline" : "Recurring"} </Text>
                      </VerticalStack>
                    ) : (
                      null
                    )
                  }
                </HorizontalStack>
                <HorizontalStack align="space-between">
                  <HorizontalStack gap="2">
                    {
                      deal?.content?.delayOnAccept && deal?.content?.delayStartDays && deal?.content?.delayStartDays !== 0 ? (
                        <HorizontalStack blockAlign="center">
                          <Icon source={ClockMinor} color="base" />
                          <Text variant="bodySm">Starts {deal?.content?.delayStartDays} Days After Accepted</Text>
                        </HorizontalStack>
                      ) : null
                    }
                  </HorizontalStack>
                </HorizontalStack>
                <Divider />
              </VerticalStack>
            </AlphaCard>
            {
              (deal?.payments?.includePayment && deal?.payments?.price) ? (
                <AlphaCard>
                  <VerticalStack gap="5">
                    <HorizontalStack align="space-between">
                      <HorizontalStack gap="3" align="start" blockAlign="center">
                        <HorizontalStack>
                          <Icon source={BehaviorMajor} />
                        </HorizontalStack>
                        <VerticalStack gap="1">
                          <Text variant="headingMd">Fixed Payment</Text>
                        </VerticalStack>
                      </HorizontalStack>
                    </HorizontalStack>
                    <Divider />
                    <HorizontalGrid gap="5" columns="2">
                      <VerticalStack>
                        <Text variant="headingLg">{numberToUSD(deal.payments?.price)}</Text>
                        <Text>{deal?.payments?.whenPayment}</Text>
                      </VerticalStack>
                    </HorizontalGrid>
                  </VerticalStack>
                </AlphaCard>
              ) : null
            }
            {
              deal?.specs?.script || deal?.specs?.creativeDirection || deal?.specs?.inspiration || deal?.assets?.length ? (
                <AlphaCard>
                  <VerticalStack gap="5">
                    <HorizontalStack gap="3" align="start">
                      <HorizontalStack>
                        <Icon source={ChecklistMajor} />
                      </HorizontalStack>
                      <VerticalStack>
                        <Text variant="headingMd">Requirements</Text>
                      </VerticalStack>
                    </HorizontalStack>
                    <Divider />
                    <VerticalStack gap="5">
                      {
                        deal?.specs?.script ? (
                          <>
                            <VerticalStack gap="2">
                              <Text variant="headingSm">Guidelines</Text>
                              <VerticalStack gap="1">
                                <div dangerouslySetInnerHTML={{ __html: deal?.specs?.script }} />
                              </VerticalStack>
                            </VerticalStack>
                            <Divider />
                          </>
                        ) : null
                      }
                      {
                        deal?.specs?.creativeDirection ? (
                          <>
                            <VerticalStack gap="2">
                              <Text variant="headingSm">Creative Direction</Text>
                              <VerticalStack gap="1">
                                <div dangerouslySetInnerHTML={{ __html: deal?.specs?.creativeDirection }} />
                              </VerticalStack>
                            </VerticalStack>
                            <Divider />
                          </>
                        ) : null
                      }
                      {
                        deal?.specs?.inspiration ? (
                          <VerticalStack gap="2">
                            <Text variant="headingSm">Inspiration Examples</Text>
                            <VerticalStack gap="1">
                              <div dangerouslySetInnerHTML={{ __html: deal?.specs?.inspiration }} />
                            </VerticalStack>
                          </VerticalStack>
                        ) : null
                      }
                      {
                        deal?.assets?.length ? (
                          <VerticalStack gap="2">
                            <Divider />
                            <Text variant="headingSm">Assets</Text>
                            <HorizontalStack gap="5" align="start">
                              {
                                deal?.assets?.map((asset, index) => {
                                  return (
                                    <HorizontalStack key={index} gap="1" blockAlign="center" align="start">
                                      <HorizontalStack>
                                        <Icon color="interactive" source={asset?.name?.includes('doc') || asset?.name?.includes('pdf') ? PagePlusMajor : ImagesMajor} />
                                      </HorizontalStack>
                                      <Link removeUnderline url={asset.url}>{asset.name}</Link>
                                    </HorizontalStack>
                                  )
                                })
                              }
                            </HorizontalStack>
                          </VerticalStack>
                        ) : null
                      }
                    </VerticalStack>
                  </VerticalStack>
                </AlphaCard>
              ) : null
            }
            {
              (deal?.products?.selectedVariants?.length) ? (
                <AlphaCard>
                  <VerticalStack gap="5">
                    <HorizontalStack blockAlign="center" align="space-between">
                      <HorizontalStack gap="3" align="start">
                        <HorizontalStack>
                          <Icon source={AddProductMajor} />
                        </HorizontalStack>
                        <VerticalStack gap="1">
                          <Text variant="headingMd">You Will Receive</Text>
                        </VerticalStack>
                      </HorizontalStack>
                      <VerticalStack inlineAlign="end">
                        <Text variant="bodyMd">Order Status</Text>
                        {
                          deal?.order?.status === 'fulfilled' ? (
                            <Badge status="info">Shipped</Badge>
                          ) : deal?.order?.id ? (
                            <Badge status="info">Order Created</Badge>
                          ) : (
                            <Badge>Pending</Badge>
                          )
                        }
                      </VerticalStack>
                    </HorizontalStack>
                    <Divider />
                    <HorizontalGrid gap="5" columns="3">
                      {
                        deal.order?.shippedVariants?.map((variant, index) => (
                          <VerticalStack key={index} gap="1">
                            <Image width="100%" source={variant.image} />
                            <HorizontalStack>
                              <Text variant="headingSm">{variant.title}</Text>
                              <Text color="subdued">${variant.price}</Text>
                            </HorizontalStack>
                          </VerticalStack>
                        ))
                      }
                    </HorizontalGrid>
                    {/*
                      <Divider />
                      <HorizontalStack gap="5">
                        {totalSelectedValue > 0 ? (
                          <VerticalStack inlineAlign="center" gap="1">
                            <Text variant="headingLg" color={Number(totalSelectedValue) <= Number(deal?.products?.maxProductValue) ? "success" : "critical"}>${totalSelectedValue}</Text>
                            <Text color="subdued">Total Value</Text>
                          </VerticalStack>
                        ) : null}
                        {totalSelectedValue > 0 ? (
                          <VerticalStack inlineAlign="center" gap="1">
                            <Text variant="headingLg" color={Number(totalSelectedQuantity) <= Number(deal?.products?.maxProductQuantity) ? "success" : "critical"} >{totalSelectedQuantity}</Text>
                            <Text color="subdued">Total Quantity</Text>
                          </VerticalStack>
                        ) : null}
                      </HorizontalStack>
                  */}
                  </VerticalStack>
                </AlphaCard>
              ) : null
            }
          </VerticalStack>
        </Box>
      </HorizontalStack>
    )
  } else if (deal?.submitted) {
    if (((deal?.payments?.price && deal?.payments?.includePayment) || deal?.payments?.includeAffiliate) && !paypalData?.data?.primary_email_confirmed) {
      console.log('paypalData', paypalData)

      if (paypalData?.data?.payments_receivable) {
        return (
          <HorizontalStack align="center">
            <Box paddingBlockStart="16" paddingBlockEnd="32" maxWidth="1000px" width="700px">
              {header}
              <VerticalStack gap="3">
                <AlphaCard>
                  <VerticalStack gap="5" inlineAlign="center">
                    <VerticalStack gap="1" inlineAlign="center">
                      <Text variant="headingXl">You're Nearly Done...</Text>
                      <Text variant="bodyLg">Just Check Your Email to Confirm Link to PayPal</Text>
                    </VerticalStack>
                  </VerticalStack>
                </AlphaCard>
              </VerticalStack>
            </Box>
          </HorizontalStack>
        )
      }
      return (
        <HorizontalStack align="center">
          <Box paddingBlockStart="16" paddingBlockEnd="32" maxWidth="1000px" width="700px">
            {header}
            <VerticalStack gap="3">
              <AlphaCard>
                <VerticalStack gap="5" inlineAlign="center">
                  <VerticalStack gap="1" inlineAlign="center">
                    <Text variant="headingXl">Last Step!</Text>
                    <Text variant="bodyLg">Add PayPal To Receive Payments Without Disruption</Text>
                  </VerticalStack>
                  <Button loading={paypalLoading || paypalDataLoading} onClick={async () => {
                    try {
                      setPaypalLoading(true)
                      const { data: link } = await getPaypalOnboardingLink({
                        creatorID: deal?.creatorID,
                        email: deal?.creator?.email,
                        dealID: deal.id
                      })
                      window.location.href = link
                    } catch (e) {
                      console.error(e)
                      alert('Error Connecting To PayPal')
                      setPaypalLoading(false)
                    }
                  }
                  } >
                    <Box padding="2">
                      <HorizontalStack gap="1">
                        <Image source={paypalIcon} width="20px" />
                        <Text variant="bodyLg">
                          Click to Connect Your PayPal
                        </Text>
                      </HorizontalStack>
                    </Box>
                  </Button>
                  <Text variant="bodyMd">Takes 1 Minute.</Text>
                </VerticalStack>
              </AlphaCard>
            </VerticalStack>
          </Box>
        </HorizontalStack>
      )
    } else {
      return (
        <VerticalStack gap="5" inlineAlign="center">
          <Box maxWidth="800px" width="500px">
            <VerticalStack gap="5">
              <Box maxWidth="800px" width="500px">
                {header}
              </Box>
              <AlphaCard>
                <VerticalStack inlineAlign="center" gap="5">
                  <Text variant="headingXl">Thank You!</Text>
                  {
                    deal?.form?.thankYouMessage ? deal?.form?.thankYouMessage.split('\n').map((item, index) => (
                      <Text key={index} variant="bodyLg" color="subdued">{item}</Text>
                    )) : <Text variant="bodyLg" color="subdued">Contract Submitted</Text>
                  }
                </VerticalStack>
              </AlphaCard>
              <Button onClick={() => setViewContract(true)}>View Contract</Button>
            </VerticalStack>
          </Box>
        </VerticalStack>
      )
    }
  } else {
    return (
      <HorizontalStack align="center">
        <Box paddingBlockStart="16" paddingBlockEnd="32" maxWidth="1000px" width="700px">
          <VerticalStack gap="3">
            {header}
            <VerticalStack gap="3">
              <AlphaCard>
                <VerticalStack gap="5">
                  <HorizontalStack gap="3" align="start">
                    <HorizontalStack>
                      <Icon source={CustomersMajor} />
                    </HorizontalStack>
                    <VerticalStack gap="1">
                      <Text variant="headingMd">Campaign Overview</Text>
                    </VerticalStack>
                  </HorizontalStack>
                  <Divider />
                  <VerticalStack gap="3">
                    <div dangerouslySetInnerHTML={{ __html: deal?.specs?.overview }} />
                  </VerticalStack>
                </VerticalStack>

              </AlphaCard>
              {
                (deal?.payments?.includeAffiliate) && (
                  <AlphaCard>
                    <VerticalStack gap="5">
                      <HorizontalStack gap="3" align="start">
                        <HorizontalStack>
                          <Icon source={BehaviorMajor} />
                        </HorizontalStack>
                        <VerticalStack gap="1">
                          <Text variant="headingMd">Affiliate</Text>
                        </VerticalStack>
                      </HorizontalStack>
                      <Divider />
                      <HorizontalGrid gap="5" columns="2">
                        {
                          deal?.affiliateFields?.discountType === 'percentage' ? (
                            <VerticalStack>
                              <Text variant="headingLg">{deal.affiliateFields?.discountPercentage}% Discount</Text>
                              <Text>For Customers</Text>
                            </VerticalStack>
                          ) : deal?.affiliateFields?.discountType === 'fixed' ? (
                            <VerticalStack>
                              <Text variant="headingLg">${deal.affiliateFields?.discountFixedValue} Discount</Text>
                              <Text>For Customers, Per Order</Text>
                            </VerticalStack>
                          ) : (
                            <VerticalStack>
                              <Text variant="headingLg">Free Shipping</Text>
                              <Text>For Customers {deal.affiliateFields?.usOnly ? ', US Only' : ''}</Text>
                            </VerticalStack>
                          )
                        }
                        <VerticalStack>
                          <Text variant="headingLg">{deal.affiliateFields?.commission}% Commission</Text>
                          <Text>On Revenue You Generate</Text>
                        </VerticalStack>
                      </HorizontalGrid>
                    </VerticalStack>
                  </AlphaCard>
                )
              }
              {
                deal?.payments?.includePayment && deal?.payments?.price ? (
                  <AlphaCard>
                    <VerticalStack gap="5">
                      <HorizontalStack gap="3" align="start">
                        <HorizontalStack>
                          <Icon source={CashDollarMajor} />
                        </HorizontalStack>
                        <VerticalStack>
                          <Text variant="headingMd">Fixed Payment</Text>
                        </VerticalStack>
                      </HorizontalStack>
                      <Divider />
                      <VerticalStack>
                        <Text variant="headingLg">${deal.payments?.price}</Text>
                        <Text color="subdued">{deal.payments?.whenPayment}</Text>
                      </VerticalStack>
                    </VerticalStack>
                  </AlphaCard>
                ) : null
              }
              <AlphaCard>
                <VerticalStack gap="5">
                  <HorizontalStack align="space-between">
                    <HorizontalStack gap="3" align="start">
                      <HorizontalStack>
                        <Icon source={ImagesMajor} />
                      </HorizontalStack>
                      <VerticalStack>
                        <Text variant="headingMd">Content</Text>
                      </VerticalStack>
                    </HorizontalStack>
                    <VerticalStack inlineAlign="center">
                      {
                        deal?.content?.baseType === 'evergreen' ? (
                          <HorizontalStack gap="1" inlineAlign="end">
                            <Text>Post as much as you want!</Text>
                            <Badge status="success">Evergreen</Badge>
                          </HorizontalStack>
                        ) : (
                          <HorizontalStack gap="1" blockAlign="center" inlineAlign="start">
                            <Text variant="headingSm">{deal?.content?.baseType === 'fixed' ? "Deadline in" : "Every"} </Text>
                            <Text variant="headingSm">{deal.content?.dueInDays} Days</Text>
                            <Badge status="info">{deal?.content?.baseType === 'fixed' ? "Fixed" : "Recurring"}</Badge>
                          </HorizontalStack>
                        )
                      }
                      {
                        deal?.content?.dueDate && (
                          new Date(deal?.content?.dueDate) < new Date() ? (
                            <Badge status="critical">overdue {new Date(deal?.content?.dueDate).toLocaleDateString()}</Badge>
                          ) : (
                            <Badge>Due {new Date(deal?.content?.dueDate)?.toLocaleDateString()}</Badge>
                          )
                        )
                      }
                    </VerticalStack>
                  </HorizontalStack>
                  <Divider />
                  <HorizontalGrid gap="5" columns="2">
                    {
                      deal?.content?.formats?.map((formatItem, index) => {
                        const format = Object.keys(formatItem)[0]
                        const quantity = formatItem[format]
                        return (
                          <ContentItem key={index} format={format} quantity={quantity} showQuantity={deal?.content?.baseType !== 'evergreen'} />
                        )
                      })
                    }
                  </HorizontalGrid>
                  <Divider />
                  <HorizontalStack align="space-between">
                    <HorizontalStack gap="2">
                      {
                        deal?.content?.delayOnAccept ? (
                          <HorizontalStack blockAlign="center" gap="1">
                            <Icon source={ClockMinor} color="base" />
                            {
                              deal?.content?.delayStartDays === 0 ? (
                                <Text variant="bodySm">Starts on Accept</Text>
                              ) : (
                                <Text variant="bodySm">Starts {deal?.content?.delayStartDays} Days After Accepted</Text>
                              )
                            }
                          </HorizontalStack>
                        ) : null
                      }
                    </HorizontalStack>
                    <HorizontalStack gap="2">
                      {
                        deal?.content?.reviewContent ? (
                          <HorizontalStack blockAlign="center">
                            <Icon source={TickMinor} color="success" />
                            <Text variant="bodySm" color="success">Content Reviewed Before Approval</Text>
                          </HorizontalStack>
                        ) : null
                      }
                    </HorizontalStack>
                  </HorizontalStack>
                </VerticalStack>
              </AlphaCard>
              {
                deal?.specs?.script || deal?.specs?.creativeDirection || deal?.specs?.inspiration || deal?.assets?.length ? (
                  <AlphaCard>
                    <VerticalStack gap="5">
                      <HorizontalStack gap="3" align="start">
                        <HorizontalStack>
                          <Icon source={ChecklistMajor} />
                        </HorizontalStack>
                        <VerticalStack>
                          <Text variant="headingMd">Requirements</Text>
                        </VerticalStack>
                      </HorizontalStack>
                      <Divider />
                      <VerticalStack gap="5">
                        {
                          deal?.specs?.script ? (
                            <>
                              <VerticalStack gap="2">
                                <Text variant="headingSm">Guidelines</Text>
                                <VerticalStack gap="1">
                                  <div dangerouslySetInnerHTML={{ __html: deal?.specs?.script }} />
                                </VerticalStack>
                              </VerticalStack>
                            </>
                          ) : null
                        }
                        {
                          deal?.specs?.creativeDirection ? (
                            <>
                              <Divider />
                              <VerticalStack gap="2">
                                <Text variant="headingSm">Creative Direction</Text>
                                <VerticalStack gap="1">
                                  <div dangerouslySetInnerHTML={{ __html: deal?.specs?.creativeDirection }} />
                                </VerticalStack>
                              </VerticalStack>
                            </>
                          ) : null
                        }
                        {
                          deal?.specs?.inspiration ? (
                            <>
                              <Divider />
                              <VerticalStack gap="2">
                                <Text variant="headingSm">Inspiration Examples</Text>
                                <VerticalStack gap="1">
                                  <div dangerouslySetInnerHTML={{ __html: deal?.specs?.inspiration }} />
                                </VerticalStack>
                              </VerticalStack>
                            </>
                          ) : null
                        }
                        {
                          deal?.assets?.length ? (
                            <VerticalStack gap="3">
                              <Divider />
                              <Text variant="headingSm">Assets</Text>
                              <HorizontalStack gap="5" align="start">
                                {
                                  deal?.assets?.map((asset, index) => {
                                    return (
                                      <HorizontalStack key={index} gap="1" blockAlign="center" align="start">
                                        <HorizontalStack>
                                          <Icon color="interactive" source={asset?.name?.includes('doc') || asset?.name?.includes('pdf') ? PagePlusMajor : ImagesMajor} />
                                        </HorizontalStack>
                                        <Link external removeUnderline url={asset.url}>{asset.name}</Link>
                                      </HorizontalStack>
                                    )
                                  })
                                }
                              </HorizontalStack>
                            </VerticalStack>
                          ) : null
                        }
                      </VerticalStack>
                    </VerticalStack>
                  </AlphaCard>
                ) : null
              }
              {
                (deal?.products?.selectedVariants?.length) ? (
                  <VerticalStack gap="3">
                    <AlphaCard>
                      <VerticalStack gap="5">
                        <HorizontalStack blockAlign="center" align="space-between">
                          <HorizontalStack gap="3" align="start">
                            <HorizontalStack>
                              <Icon source={AddProductMajor} />
                            </HorizontalStack>
                            <VerticalStack gap="1">
                              {
                                deal.products?.choice === 'Creators Can Choose' ? (
                                  <Text variant="headingMd">Choose Your Products</Text>
                                ) : (
                                  <Text variant="headingMd">You'll Receive These Products</Text>
                                )
                              }
                            </VerticalStack>
                          </HorizontalStack>
                          {
                            deal.products?.choice === 'Creators Can Choose' ? (
                              <VerticalStack>
                                {
                                  deal.products?.maxProductValue ? (
                                    <Text color="subdued">Up to ${deal.products?.maxProductValue} in Value</Text>
                                  ) : null
                                }
                                {
                                  deal.products?.maxProductQuantity ? (
                                    <Text color="subdued">Up to {deal.products?.maxProductQuantity} Product(s)</Text>
                                  ) : null
                                }
                              </VerticalStack>
                            ) : null
                          }
                        </HorizontalStack>
                        <Divider />
                        <HorizontalGrid gap="5" columns="3" alignItems="end">
                          {

                            deal.products?.choice === 'Creators Can Choose' ? (
                              Object.values(groupedVariants)?.map((group, index) => {
                                const product = group.product;
                                const variants = group.variants
                                console.log('variants are', variants)
                                const variantImage = localCampaign?.products?.selectedVariants?.find((item) => item.productID === product.productID)?.image || product.productImage;
                                return (
                                  <VerticalStack inlineAlign="center" key={index} gap="1">
                                    <Box width="150px" height="150px">
                                      <Image width="100%" source={variantImage} />
                                    </Box>
                                    <VerticalStack gap="1" inlineAlign="start">
                                      {
                                        deal.products?.choice === 'Creators Can Choose' ? (
                                          <Checkbox
                                            checked={localCampaign?.products?.selectedVariants?.find((item) => item.productID === product.productID)}
                                            onChange={(value) => {
                                              if (localCampaign?.products?.selectedVariants?.find((item) => item.productID === product.productID)) {
                                                setLocalCampaign({
                                                  ...localCampaign,
                                                  products: {
                                                    ...(localCampaign?.products || []),
                                                    selectedVariants: localCampaign?.products?.selectedVariants?.filter((item) => item.productID !== product.productID)
                                                  }
                                                })
                                              } else {
                                                const variant = localSelectedVariants[product.productID]
                                                setLocalCampaign({
                                                  ...localCampaign,
                                                  products: {
                                                    ...(localCampaign?.products || []),
                                                    selectedVariants: [...(localCampaign?.products?.selectedVariants || []), variant]
                                                  }
                                                })
                                              }
                                            }}
                                          />
                                        ) : null
                                      }
                                      <VerticalStack gap="1" inlineAlign="start">
                                        <Text variant="headingSm">{product.productTitle}</Text>
                                        {
                                          variants?.length > 1 ? (
                                            <div style={{ width: '100%' }}>
                                              <Select value={localSelectedVariants[product.productID]?.title?.split(' - ')[1] || localSelectedVariants[product.productID]?.title} onChange={(value) => {
                                                const variant = variants.find(variant => (variant.title.split(' - ')[1] || variant.title) === value)
                                                if (localCampaign?.products?.selectedVariants?.find((item) => item.productID === product.productID)) {
                                                  const newVariants = [...(localCampaign?.products?.selectedVariants || []).filter(v => !(v.productID === product.productID))]
                                                  newVariants.push(variant)
                                                  setLocalCampaign({
                                                    ...localCampaign,
                                                    products: {
                                                      ...(localCampaign?.products || []),
                                                      selectedVariants: newVariants
                                                    }
                                                  })
                                                }
                                                setLocalSelectedVariants({
                                                  ...localSelectedVariants,
                                                  [product.productID]: variant
                                                })

                                              }} options={variants.map((variant) => {
                                                return variant?.title.split(' - ')[1] || variant.title
                                              })} />
                                            </div>
                                          ) : null
                                        }
                                        <Text color="subdued">${product.price}</Text>
                                      </VerticalStack>
                                    </VerticalStack>
                                  </VerticalStack>
                                )
                              })
                            ) : (
                              deal.products?.selectedVariants?.map((variant, index) => (
                                <VerticalStack key={index} gap="1">
                                  <Box onClick={() => {
                                    if (localCampaign?.products?.selectedVariants?.find((item) => item.id === variant.id)) {
                                      setLocalCampaign({
                                        ...localCampaign,
                                        products: {
                                          ...(localCampaign?.products || []),
                                          selectedVariants: localCampaign?.products?.selectedVariants?.filter((item) => item.id !== variant.id)
                                        }
                                      })
                                    } else {
                                      setLocalCampaign({
                                        ...localCampaign,
                                        products: {
                                          ...(localCampaign?.products || []),
                                          selectedVariants: [...(localCampaign?.products?.selectedVariants || []), variant]
                                        }
                                      })
                                    }
                                  }}>
                                    <Box width="150px" height="150px">
                                      <Image width="100%" source={variant.image} />
                                    </Box>
                                    <VerticalStack gap="1" inlineAlign="start">
                                      <Text variant="headingSm">{variant.title}</Text>
                                      <Text color="subdued" variant="bodyMd">${variant.price}</Text>
                                    </VerticalStack>
                                  </Box>
                                </VerticalStack>
                              ))
                            )
                          }
                        </HorizontalGrid>
                        <Divider />
                        {
                          deal.products?.choice === 'Creators Can Choose' ? (
                            <HorizontalStack gap="5">
                              {totalSelectedValue > 0 ? (
                                <VerticalStack inlineAlign="center" gap="1">
                                  <Text variant="headingLg" color={Number(totalSelectedValue) <= Number(deal?.products?.maxProductValue) ? "success" : "critical"}>${totalSelectedValue}</Text>
                                  <Text color="subdued">Total Value</Text>
                                </VerticalStack>
                              ) : null}
                              {totalSelectedValue > 0 ? (
                                <VerticalStack inlineAlign="center" gap="1">
                                  <Text variant="headingLg" color={Number(totalSelectedQuantity) <= Number(deal?.products?.maxProductQuantity) ? "success" : "critical"} >{totalSelectedQuantity}</Text>
                                  <Text color="subdued">Total Quantity</Text>
                                </VerticalStack>
                              ) : null}
                            </HorizontalStack>
                          ) : null
                        }
                      </VerticalStack>
                    </AlphaCard>
                    {
                      !creatorAddress?.data?.address?.line1 ? (
                        <AlphaCard>
                          <VerticalStack gap="5">
                            <HorizontalStack blockAlign="center" align="space-between">
                              <HorizontalStack gap="3" align="start">
                                <HorizontalStack>
                                  <Icon source={ShipmentMajor} />
                                </HorizontalStack>
                                <Text variant="headingMd">Shipping Address</Text>
                              </HorizontalStack>
                            </HorizontalStack>
                            <Divider />
                            <AddressElement
                              onChange={v => {
                                setLocalCampaign({
                                  ...localCampaign,
                                  shippingAddress: v?.value
                                })
                              }}
                              options={{
                                mode: 'shipping',
                                autocomplete: {
                                  mode: 'google_maps_api',
                                  apiKey: MAPS_KEY,
                                },
                                defaultValues: {}
                              }} />
                          </VerticalStack>
                        </AlphaCard>
                      ) : null
                    }
                  </VerticalStack>
                ) : null
              }
            </VerticalStack>
            {
              deal?.form?.customFields?.length ? (
                <AlphaCard>
                  <VerticalStack gap="5">
                    <HorizontalStack gap="3" align="start">
                      <HorizontalStack>
                        <Icon source={FormsMajor} />
                      </HorizontalStack>
                      <Text variant="headingMd">Questions</Text>
                    </HorizontalStack>
                    <Divider />
                    {
                      deal?.form?.customFields?.map((field, index) => {
                        return (
                          <VerticalStack key={index} gap="3">
                            {
                              field.type === 'text' ? (
                                <VerticalStack gap="2">
                                  <TextField
                                    label={field.label}
                                    requiredIndicator={field.required}
                                    value={localCampaign?.customFields?.[field.label]}
                                    multiline={field.multiline ? 2 : false}
                                    onChange={v => {
                                      setLocalCampaign({
                                        ...localCampaign,
                                        customFields: {
                                          ...(localCampaign?.customFields || {}),
                                          [field.label]: v
                                        }
                                      })
                                    }}
                                  />
                                </VerticalStack>
                              ) : null
                            }
                            {
                              field.type === 'checkbox' ? (
                                <VerticalStack gap="2">
                                  <HorizontalStack gap="1" align="start">
                                    <Text variant="bodyMd">{field.label}</Text>
                                    {
                                      field.required ? (
                                        <Text color="critical">*</Text>
                                      ) : null
                                    }
                                  </HorizontalStack>
                                  <HorizontalStack gap="5" align="start">
                                    {
                                      field.options.map((option, index) => {
                                        return (
                                          <Checkbox
                                            key={index}
                                            label={option}
                                            checked={localCampaign?.customFields?.[field.label]?.includes(option)}
                                            onChange={() => {
                                              if (localCampaign?.customFields?.[field.label]?.includes(option)) {
                                                setLocalCampaign({
                                                  ...localCampaign,
                                                  customFields: {
                                                    ...(localCampaign?.customFields || {}),
                                                    [field.label]: localCampaign?.customFields?.[field.label]?.filter((item) => item !== option)
                                                  }
                                                })
                                              } else {
                                                setLocalCampaign({
                                                  ...localCampaign,
                                                  customFields: {
                                                    ...(localCampaign?.customFields || {}),
                                                    [field.label]: [...(localCampaign?.customFields?.[field.label] || []), option]
                                                  }
                                                })
                                              }
                                            }}
                                          />
                                        )
                                      })
                                    }
                                  </HorizontalStack>
                                </VerticalStack>
                              ) : null
                            }
                            {
                              field.type === 'select' ? (
                                <Select
                                  label={field.label}
                                  options={field.options}
                                  requiredIndicator={field.required}
                                  value={localCampaign?.customFields?.[field.label]}
                                  onChange={v => {
                                    setLocalCampaign({
                                      ...localCampaign,
                                      customFields: {
                                        ...(localCampaign?.customFields || {}),
                                        [field.label]: v
                                      }
                                    })
                                  }}
                                />
                              ) : null
                            }
                          </VerticalStack>
                        )
                      })
                    }
                  </VerticalStack>
                </AlphaCard>
              ) : (
                null
              )
            }
            <AlphaCard>
              <VerticalStack gap="5">
                <HorizontalStack blockAlign="center" align="space-between">
                  <HorizontalStack gap="3" align="start">
                    <HorizontalStack>
                      <Icon source={LegalMajor} />
                    </HorizontalStack>
                    <VerticalStack gap="1">
                      <Text variant="headingMd">Content Terms & Rights</Text>
                    </VerticalStack>
                  </HorizontalStack>
                </HorizontalStack>
                <Divider />
                <VerticalStack gap="5">
                  <VerticalStack gap="1">
                    <div dangerouslySetInnerHTML={{ __html: deal?.contentRights?.terms }} />
                  </VerticalStack>
                </VerticalStack>
                <HorizontalStack align="end" gap="5">
                  <VerticalStack gap="3">
                    {
                      deal?.contentRights?.digitalSignature ? (
                        <VerticalStack gap="1">
                          <Text>Signature</Text>
                          <input type="text" style={{ fontFamily: 'cursive', border: '1px solid grey', borderRadius: '5px', padding: '5px', fontSize: '16px' }} onChange={e => {
                            setLocalCampaign({
                              ...localCampaign,
                              contentRights: {
                                ...localCampaign?.contentRights,
                                signature: e?.target?.value
                              }
                            })
                          }} />
                        </VerticalStack>
                      ) : null
                    }
                    <Checkbox label="I agree to these terms and conditions" checked={localCampaign?.contentRights?.agreed} onChange={() => setLocalCampaign({
                      ...localCampaign,
                      contentRights: {
                        ...localCampaign?.contentRights,
                        agreed: !localCampaign?.contentRights?.agreed
                      }
                    })} />
                  </VerticalStack>
                </HorizontalStack>
              </VerticalStack>
            </AlphaCard>
            <HorizontalStack align="end">
              <Button
                loading={submitFormLoading}
                primary
                onClick={handleSubmitCampaign}
                disabled={
                  (deal?.products?.choice === 'Creators Can Choose' && Number(totalSelectedValue) > Number(deal?.products?.maxProductValue)) ||
                  (deal?.products?.choice === 'Creators Can Choose' && Number(totalSelectedQuantity) > Number(deal?.products?.maxProductQuantity)) ||
                  (deal?.contentRights?.terms && !localCampaign?.contentRights?.agreed) ||
                  (deal?.contentRights?.digitalSignature && !localCampaign?.contentRights?.signature) ||
                  (deal?.products?.selectedVariants?.length && !creatorAddress?.data?.address && !localCampaign?.shippingAddress?.address?.line1) ||
                  (hasMissingFields())
                }
              >
                {deal?.form?.reviewApplicantsManually ? "Apply Now" : "Accept Offer"}
              </Button>
            </HorizontalStack>
            <Text color="critical">{submitFormError}</Text>
            <Divider />
            <VerticalStack gap="3" inlineAlign="center">
              <Text>Questions? Contact Us</Text>
              <Text>{deal?.store?.contactEmail || deal?.store?.email}</Text>
            </VerticalStack>
          </VerticalStack>
        </Box>
      </HorizontalStack>
    )
  }
}
